import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function HomePage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-gradient-to-b from-saffron-50 to-background p-6">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <p className="text-xs font-semibold uppercase tracking-wider text-saffron-700">
            ISKCON Pune · BCEC
          </p>
          <CardTitle className="text-2xl">Attendance Portal</CardTitle>
          <CardDescription>
            Coordinators and devotees — choose your area below.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Button asChild size="lg">
            <Link to="/me/login">Devotee / Employee</Link>
          </Button>
          <Button asChild variant="outline" size="lg">
            <Link to="/admin/login">Coordinator (Admin)</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
